<template>
  <div id="app" class="w-full overflow-hidden">
    <Loading :active="isLoading"></Loading>
    <router-view></router-view>
  </div>
</template>
<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/css/index.css';
  export default {
    components: {
      Loading
    },
    setup () {
      const store = useStore()
      const isLoading = computed(() => store.getters['isLoading'])

      return {
        isLoading
      }
    }
  }
  </script>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
